import { QueryFilterOperator } from '../utils/query-const';

export const ToastMessage = {
    ERROR_OCCURED: () => '🔴 Произошла ошибка',
    DATA_PROVIDER_CHANGED: ({ name }) => `Провайдер данных изменен: ${name}`,
    IMPORTED_SUCCESSFULLY: () => 'Успешно импортировано',
    COPIED_TO_CLIPBOARD: () => 'Скопировано в буфер'
};

export const QueryFilterOperatorPlaceholder = {
    [QueryFilterOperator.EQ]: (str) => [str],
    [QueryFilterOperator.EQ_NOT]: (str) => [str],
    [QueryFilterOperator.IS]: (str) => [str],
    [QueryFilterOperator.IS_NOT]: (str) => [str],
    [QueryFilterOperator.LESS]: (str) => [str],
    [QueryFilterOperator.LESS_EQ]: (str) => [str],
    [QueryFilterOperator.GREATER]: (str) => [str],
    [QueryFilterOperator.GREATER_EQ]: (str) => [str],
    [QueryFilterOperator.IN]: (str) => [str, str, str],
    [QueryFilterOperator.IN_NOT]: (str) => [str, str, str],
    [QueryFilterOperator.BETWEEN]: (str) => [str, str],
    [QueryFilterOperator.BETWEEN_NOT]: (str) => [str, str],
    [QueryFilterOperator.LIKE]: (str) => [str]
};


export const EntityType = {
    METRIC: 'metric',
    DIMENSION: 'dimension',
    DRILLDOWN: 'drilldown',
    FIELD: 'field',
    VARIABLE: 'variable',
    FILTER: 'filter',
    SORT: 'sort'
};

export const EntityTypeMeta = {
    [EntityType.METRIC]: { icon: 'mdi-gauge' },
    [EntityType.DIMENSION]: { icon: 'mdi-axis-arrow' },
    [EntityType.DRILLDOWN]: { icon: 'mdi-layers-outline' }
};
